module.exports = __webpack_public_path__ + "static/media/A2_21.8480b960.png";